import { AdhesionPaymentResumeInterface } from '../../../../interfaces/dto/sales-portal/adhesion-payment/adhesion-payment-resume-interface';

export class AdhesionPaymentResumeModel implements AdhesionPaymentResumeInterface {
  paymentMethod: string = '';
  prizeValue: number = -1;
  paymentFractioning: string = '';

  constructor(init?: Partial<AdhesionPaymentResumeModel>) {
    Object.assign(this, init);
  }
}
